export default {
    name: 'Terminal3',
    dimensions: { width: 20, height: 21 },
    content: `
    <g>
      <path stroke="currentColor" d="M1 10.5H15" fill="none" stroke-width="2"/>
      <rect fill="none" stroke="currentColor" x="1" y="1.5" width="14" height="18" rx="2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M19 3.5V17.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="5" cy="13.5" r="1" fill="currentColor"/>
      <circle cx="5" cy="16.5" r="1" fill="currentColor"/>
      <circle cx="8" cy="13.5" r="1" fill="currentColor"/>
      <circle cx="8" cy="16.5" r="1" fill="currentColor"/>
      <circle cx="11" cy="13.5" r="1" fill="currentColor"/>
      <circle cx="11" cy="16.5" r="1" fill="currentColor"/>
    </g>
  `
};
